module.exports = __webpack_public_path__ + "icon-play-large.74057c9a8c2d845d7fbb.svg";


//////////////////
// WEBPACK FOOTER
// /Users/benmeden/Documents/Projects/Maestro/abem-examiner-demo/src/assets/icons/icon-play-large.svg
// module id = ../../../../../src/assets/icons/icon-play-large.svg
// module chunks = styles